import React, { useContext } from 'react'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Button, theme } from 'antd'
import { SectionHeadingElementIdContext } from './section-well'
import './org-dashboard.scss'

type Props = { sectionName: string; onRetry: () => void }

/**
 * A section that could not be read. The retry refetches that section alone, so the message says nothing else is
 * affected. The retry button is removed while the section reloads, which would drop keyboard focus to the page, so
 * focus moves to the section's heading first.
 */
export const SectionError: React.FC<Props> = ({ sectionName, onRetry }) => {
    const { token } = theme.useToken()
    const sectionHeadingElementId = useContext(SectionHeadingElementIdContext)
    const retry = () => {
        onRetry()
        if (sectionHeadingElementId) document.getElementById(sectionHeadingElementId)?.focus()
    }
    return (
        <div className="org-dashboard-section-message" role="alert">
            <ExclamationCircleFilled aria-hidden="true" style={{ fontSize: 32, color: token.colorError }} />
            <strong>{`Failed to load ${sectionName}.`}</strong>
            <span className="org-dashboard-section-message-detail">The rest of the dashboard is unaffected.</span>
            <Button onClick={retry}>Try Again</Button>
        </div>
    )
}
